import { useQuery } from '@tanstack/react-query';
import { getPublicUserDoc } from '@util/firestore/users';
import { ProductDocument } from 'models/product';
import Image from 'next/image';
import PlaneIcon from './icons/assets/plane.svg';

export default function SellerVacationDisplay({
  product,
}: {
  product: ProductDocument;
}) {
  const { data: seller } = useQuery({
    queryKey: ['publicUser', product.seller_id],
    queryFn: () => getPublicUserDoc({ uid: product.seller_id }),
  });

  if (!product || !seller || !seller.on_vacation) return null;

  return (
    <div className="flex items-center gap-x-4 rounded-[1.5rem] bg-[#F1F1F1] p-4">
      <Image src={PlaneIcon} alt="plane" width={20} height={20} />

      <p className="text-[1.6rem] font-semibold text-black">
        This seller is on vacation. If you buy this item, expect a delay in
        shipping.
      </p>
    </div>
  );
}
